<div class="overlay">
  <p-progressSpinner
    [style]="{ width: '50px', height: '50px' }"
    styleClass="custom-spinner"
    strokeWidth="8"
    fill="#EEEEEE"
    animationDuration=".5s"
  ></p-progressSpinner>
</div>
